export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;

export const LOGIN_URL = BASE_URL + '/auth/login';
export const USER_URL = BASE_URL + '/user';
export const SKILL_URL = USER_URL + '/skills';
export const NOTIFICATION_URL = BASE_URL + '/notification';
export const FORMS_URL = BASE_URL + '/forms';
export const SELF_USER_FORM = FORMS_URL + '/self-user-form';
export const ATTENDANCE_URL = BASE_URL + '/attendance';
export const PROJECT_URL = BASE_URL + '/projects';
export const CLIENT_URL = BASE_URL + '/client';
export const EXPENSE_URL = BASE_URL + '/expenses';
export const TEAM_CONTRIBUTIONS_URL = BASE_URL + '/team-contributions';
export const REFUND_URL = BASE_URL + '/refund';
export const DEPARTMENT_URL = BASE_URL + '/departments';
export const LEAVE_DAYS_URL = BASE_URL + '/leave-days';
export const HOLIDAY_URL = BASE_URL + '/holiday';
export const MODULE_URL = BASE_URL + '/module';
export const COMPANY_SETTINGS_URL = BASE_URL + '/company-settings';
